import { render, staticRenderFns } from "./Tumblr.vue?vue&type=template&id=a0b2a072"
import script from "./Tumblr.vue?vue&type=script&lang=js"
export * from "./Tumblr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports